import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import BoxWrapper from 'components/atoms/BoxWrapper';
import CustomTypography from 'components/atoms/CustomTypography';
import LinkButton from 'components/atoms/LinkButton';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';

const WelcomePage = () => {
    return (
        <>
            <HeaderTemplate title="Welcome" />
            <Container>
                <BoxWrapper mt="50">
                    <Grid container justify="center">
                        <Grid item xs={12} md={6}>
                            <BoxWrapper mb="50" justifyContent="flex-start">
                                <CustomTypography align="center" fontSize="2.6">
                                    Welcome to Mobilise Moments, a new interactive way for carers to
                                    make themselves heard and receive support. Each day we ask the
                                    community a quick question, this is followed up with the results
                                    from the previous day as well as providing you with a useful or
                                    uplifting 'nugget'.
                                </CustomTypography>
                            </BoxWrapper>
                            <BoxWrapper>
                                <LinkButton to="/register" width="50">
                                    Get started
                                </LinkButton>
                            </BoxWrapper>
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </Container>
        </>
    );
};

export default WelcomePage;
